
import { FindRankingUsersResponse, RankingBasicProjectsResponse, RankingProjectsResponse, RankingUsersResponse, SetRankingPositionResponse } from "../../interfaces/ranking"
import { LevelInfoResponse } from "../../interfaces/user"
import {useFetch} from "./useFetch"

export const useRankingFetch = () => {

    const {authFetch} = useFetch()

    const postJson = async (path : string, body : any) => {
        return await authFetch(
            process.env.REACT_APP_AUTH_API_URL + path,
            {
                method : 'POST',
                body : JSON.stringify(body),
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache'
                },
            }
        )
    }

    const getUsersRanking = async (country_id : number): Promise<RankingUsersResponse> => {

        const response : RankingUsersResponse = await authFetch(
            process.env.REACT_APP_AUTH_API_URL + '/api/ranking/get-users-ranking',
            {
                method : 'POST',
                body : JSON.stringify({country_id : country_id}),
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache'
                },
            }
        )
        
        return response;
    }

    const getProjectsRanking = async (country_id : number): Promise<RankingProjectsResponse> => {

        const response : RankingProjectsResponse = await authFetch(
            process.env.REACT_APP_AUTH_API_URL + '/api/ranking/get-projects-ranking',
            {
                method : 'POST',
                body : JSON.stringify({country_id : country_id}),
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache'
                },
            }
        )
        
        return response;
    }

    //Solo admin (nivel 11 + rol admin): buscar inmobiliarias/usuarios para asignarles posición
    const findUsersRanking = async (search : string): Promise<FindRankingUsersResponse> => {

        const response : FindRankingUsersResponse = await postJson('/api/ranking/find-user', {search : search})

        return response;
    }

    //Solo admin: fija manual_points para que el usuario quede en la posición indicada (1 a 3)
    const setUserRankingPosition = async (user_id : number, position : number): Promise<SetRankingPositionResponse> => {

        const response : SetRankingPositionResponse = await postJson('/api/ranking/set-user-position', {user_id : user_id, position : position})

        return response;
    }

    //Solo admin: vuelve manual_points a 0, el usuario rankea de nuevo por ventas
    const removeUserRankingPosition = async (user_id : number): Promise<SetRankingPositionResponse> => {

        const response : SetRankingPositionResponse = await postJson('/api/ranking/remove-user-position', {user_id : user_id})

        return response;
    }

    //Solo admin: fija manual_points del proyecto para la posición indicada (1 a 3)
    const setProjectRankingPosition = async (identifier : string, position : number): Promise<SetRankingPositionResponse> => {

        const response : SetRankingPositionResponse = await postJson('/api/ranking/set-project-position', {identifier : identifier, position : position})

        return response;
    }

    //Solo admin: vuelve manual_points del proyecto a 0
    const removeProjectRankingPosition = async (identifier : string): Promise<SetRankingPositionResponse> => {

        const response : SetRankingPositionResponse = await postJson('/api/ranking/remove-project-position', {identifier : identifier})

        return response;
    }

    //Listado plano de proyectos (activos e inactivos) para el selector del ranking
    const getProjectsForRanking = async (): Promise<RankingBasicProjectsResponse> => {

        const response : RankingBasicProjectsResponse = await postJson('/api/projects/get-projects-basic', {list_inactives : true, limit : 5000})

        return response;
    }

    return {
        getUsersRanking,
        getProjectsRanking,
        findUsersRanking,
        setUserRankingPosition,
        removeUserRankingPosition,
        setProjectRankingPosition,
        removeProjectRankingPosition,
        getProjectsForRanking
    }
}